var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndergroundLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 212,
    height: 52,
    viewBox: "0 0 212 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(1498 520.678)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_174538",
    "data-name": "Group 174538",
    transform: "translate(-1498 -520.678)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161467",
    "data-name": "Rectangle 161467",
    width: 212,
    height: 52,
    transform: "translate(0 0)",
    fill: "#d71d24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_174537",
    "data-name": "Group 174537",
    transform: "translate(13.541 14.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40544",
    "data-name": "Path 40544",
    d: "M-606.525,195.342l4.977-.063-3.206,18.185h5.347l3.2-18.122h4.833l-3.423,19.407-3.933,3.316h-8.447l-2.788-3.189Z",
    transform: "translate(609.97 -195.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40545",
    "data-name": "Path 40545",
    d: "M-587.006,195.354h6.1l2.716,12.759,2.183-12.759h4.748l-4.006,22.723h-6.3l-2.294-13.535-2.354,13.535h-4.732Z",
    transform: "translate(607.029 -195.227)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40546",
    "data-name": "Path 40546",
    d: "M-566.461,195.354h11.846l2.8,3.205-2.87,16.281-3.8,3.206h-11.98Zm4.057,4.491-2.418,13.71h5.515l2.418-13.71Z",
    transform: "translate(603.863 -195.227)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40547",
    "data-name": "Path 40547",
    d: "M-546.4,195.354h12.514l-.791,4.491h-7.665l-.767,4.348,7.672-.048-.833,4.73-7.653-.064-.837,4.745,7.647.1-.775,4.4H-550.4Z",
    transform: "translate(600.762 -195.227)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40548",
    "data-name": "Path 40548",
    d: "M-518.158,195.268l2.933,3.205-1.195,6.774L-518.8,207.3l1.677,1.92-1.537,8.711H-523.5l1.537-8.711h-5.565l-1.507,8.838h-4.833l4.029-22.85Zm-7.677,4.6-.858,4.871h5.515l.858-4.871Z",
    transform: "translate(598.208 -195.204)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40549",
    "data-name": "Path 40549",
    d: "M-506.773,195.28h8.78l2.643,3.347-.521,2.952h-5l.315-1.793h-5.4l-2.426,13.757,5.521.064.834-4.729-2.01-.032.78-4.427h6.88l-1.813,10.282-3.823,3.349h-8.647l-2.815-3.222,2.9-16.455Z",
    transform: "translate(595.054 -195.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40550",
    "data-name": "Path 40550",
    d: "M-478.407,195.268l2.934,3.205-1.195,6.774-2.376,2.048,1.676,1.92-1.536,8.711h-4.848l1.536-8.711h-5.566l-1.507,8.838h-4.832l4.028-22.85Zm-7.675,4.6-.86,4.871h5.515l.859-4.871Z",
    transform: "translate(592.063 -195.204)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40551",
    "data-name": "Path 40551",
    d: "M-466.875,195.354h8.581l2.786,3.191-2.907,16.486-3.887,3.062h-8.448l-2.915-3.316,2.862-16.232Zm.789,4.6-2.409,13.662h5.5l2.409-13.662Z",
    transform: "translate(588.902 -195.227)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40552",
    "data-name": "Path 40552",
    d: "M-450.123,195.342l4.976-.063-3.205,18.185H-443l3.2-18.122h4.833l-3.423,19.407-3.935,3.316h-8.447l-2.787-3.189Z",
    transform: "translate(585.795 -195.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40553",
    "data-name": "Path 40553",
    d: "M-430.6,195.354h6.1l2.714,12.759,2.184-12.759h4.75l-4.007,22.723h-6.3l-2.3-13.535-2.353,13.535h-4.732Z",
    transform: "translate(582.855 -195.227)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40554",
    "data-name": "Path 40554",
    d: "M-410.061,195.354h11.846l2.8,3.205-2.872,16.281-3.8,3.206h-11.98Zm4.056,4.491-2.416,13.71h5.515l2.416-13.71Z",
    transform: "translate(579.689 -195.227)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndergroundLogo);
export default __webpack_public_path__ + "static/media/underground-logo.a0a0a324f7260764ed6302d2b6e3f85e.svg";
export { ForwardRef as ReactComponent };